export default __webpack_public_path__ + "static/media/CardSauna2.16da13eb.jpg";